"use client";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import {
  FiExternalLink,
  FiFacebook,
  FiInstagram,
  FiMenu,
  FiX,
  FiYoutube,
} from "react-icons/fi";
import { useIsScrolled } from "../../helper/util";
import { LanguageSwitch } from "../LanguageSwitch";
import { TTBLLogo } from "./SVG";
import { dynLink } from "@/helper/urlHelper";

// function getTitle(pathname: string) {
//   const section = pathname.split("/")[1] ?? "";
//   switch (section) {
//     case "":
//     case "currentgameday":
//     case "table":
//     case "rankings":
//     case "livestreams":
//       return "Title_Table_Tennis_Bundesliga";
//     case "news":
//       return "Title_News";
//     case "bundesliga":
//       return "Title_Bundesliga";
//     case "pokal":
//       return "Title_Pokal";
//     case "about":
//       return "Title_About_Us";
//     default:
//       return "";
//   }
// }

export function MobileNav() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  // const { pathname } = useRouter();
  // const { t } = useTranslation();
  const { scrolled } = useIsScrolled();
  return (
    <>
      <MobileOpenNav
        setMobileNavOpen={setMobileNavOpen}
        mobileNavOpen={mobileNavOpen}
      />
      <div
        className={`py-4 bg-white sticky top-0 lg:hidden z-10 ${
          scrolled && "shadow-md"
        }`}
      >
        <div className="px-4 flex justify-between w-full">
          <button className="" onClick={() => setMobileNavOpen(true)}>
            <FiMenu className="w-8 h-8" />
          </button>
          <Link href="/">
            <TTBLLogo className="w-auto h-8" />
          </Link>
          {/* <Share /> */}
          <div className="w-[32px]" />
        </div>
      </div>
      {/* <div className="container container_content lg:hidden">
        <Headline level={1}>{t(getTitle(pathname))}</Headline>
      </div> */}
    </>
  );
}

interface MobileOpenNavProps {
  setMobileNavOpen: (open: boolean) => void;
  mobileNavOpen: boolean;
}
function MobileOpenNav({
  setMobileNavOpen,
  mobileNavOpen,
}: MobileOpenNavProps) {
  const { t } = useTranslation();
  return mobileNavOpen ? (
    <div className="mobileNav w-screen h-screen fixed left-0 top-0 bg-white z-20 overflow-x-scroll p-4 lg:hidden pb-64">
      <div className="flex flex-col">
        <div className="flex justify-between">
          <button onClick={() => setMobileNavOpen(false)}>
            <FiX className="w-8 h-8" />
          </button>
          <LanguageSwitch />
        </div>
        <Link className="btn btnAction mt-4 text-center" href="/tickets">
          {t("Button_Ticket")}
        </Link>
        <hr className="my-5" />
        <Link
          className="btn btnExternal btnDYN mb-3"
          href={dynLink}
          target="_blank"
        >
          <div>
            <Image
              src="/logos/Dyn_Logo.png"
              alt="Logo DYN"
              className=""
              width={173}
              height={20}
            />
          </div>
          <div>{t("Button_DYN")}</div>
          <div>
            <FiExternalLink className="text-lg" />
          </div>
        </Link>
        <a
          href="https://www.youtube.com/channel/UCRnDl9NtKQDZVLn06Bwskrg"
          target="_blank"
          className="btn btnExternal btnYoutube mb-5"
        >
          <div>
            <FiYoutube className="" />
          </div>
          <div className="">{t("Button_Youtube")}</div>
          <div>
            <FiExternalLink className="text-lg" />
          </div>
        </a>
        <div>
          <div className="flex justify-around text-2xl">
            <a href="https://www.facebook.com/ttbuli" target="_blank">
              <FiFacebook />
            </a>
            <a href="https://www.instagram.com/ttbuli/" target="_blank">
              <FiInstagram />
            </a>
            <div>
              <a href="https://www.tiktok.com/@ttbl?lang=de-DE" target="_blank">
                <svg
                  width="19.9400095px"
                  height="22.9421458px"
                  viewBox="0 0 19.9400095 22.9421458"
                  version="1.1"
                >
                  <title>TikTok</title>
                  <g
                    id="Symbols"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="social_media/tiktok"
                      transform="translate(-2.029990, -0.530000)"
                      fill="#051726"
                      fillRule="nonzero"
                    >
                      <path
                        d="M16.0783095,0.53 C16.6140257,0.53 17.0483095,0.964283793 17.0483095,1.5 C17.0483095,2.59453336 17.4021849,3.51552625 18.1257089,4.30933423 C18.8304774,5.08256474 19.7805432,5.49162687 21.0370784,5.53969327 C21.5579868,5.55961964 21.97,5.987695 21.97,6.50898434 L21.97,10.1299028 C21.97,10.6920236 21.4937071,11.1364479 20.9329316,11.0975814 C19.6541347,11.0089498 18.7049083,10.8674519 18.0566642,10.658801 C17.7975308,10.5753934 17.511988,10.4587729 17.1984434,10.3087819 L17.076,10.248 L17.0768335,15.2802777 C17.0768335,19.6983286 14.3948171,22.7709791 10.7633984,23.3692415 L10.5252386,23.4047389 C6.16730099,23.9864654 2.13532727,20.7391823 2.03222645,16.1281586 C1.9284344,11.4862205 5.45033963,7.99545723 10.0485885,8.25668262 C10.562104,8.28585531 10.9635718,8.71077768 10.9635718,9.22512114 L10.9635718,12.9202636 C10.9635718,13.5062034 10.4480533,13.9583734 9.86711416,13.8819852 C8.47976781,13.6995618 7.50910686,14.6748952 7.50910686,15.9696903 C7.50910686,17.0884542 8.53095384,18.0049974 9.53367377,17.8891666 C10.9931404,17.720574 11.5371899,17.1748543 11.5371899,15.2802777 L11.5371899,1.5 C11.5371899,0.964283793 11.9714736,0.53 12.5071899,0.53 L16.0783095,0.53 Z M15.18,2.47 L13.477,2.47 L13.4771899,15.2802777 C13.4771899,18.1211004 12.2305966,19.4576063 9.97108516,19.7882817 L9.75629556,19.8163509 C7.59867802,20.0655916 5.56910686,18.2451726 5.56910686,15.9696903 C5.56910686,13.951119 6.92837535,12.2579716 8.90694722,11.9641214 L9.023,11.95 L9.023,10.207 L8.84445072,10.2251151 C6.02118694,10.5579817 4.00201479,12.8311005 3.97036994,15.8564952 L3.97174168,16.0847917 C4.04837865,19.5122609 7.03052267,21.914029 10.2685513,21.4817954 C13.0678853,21.1081216 15.1368335,18.8103463 15.1368335,15.2802777 L15.1368335,8.58525093 C15.1368335,7.82357517 15.9744788,7.35906489 16.6205609,7.76246044 C17.4995855,8.31129884 18.1847128,8.66199931 18.6510624,8.81210367 C18.9228601,8.89958745 19.3133895,8.97737226 19.816976,9.04262224 L20.03,9.068 L20.03,7.384 L19.7750764,7.3387547 C18.6409193,7.10721663 17.6702167,6.59975048 16.8844841,5.81747213 L16.6919169,5.61617794 C15.9040565,4.75178387 15.4072075,3.75521033 15.2080243,2.64601355 L15.18,2.47 Z"
                        id="Rectangle-Copy"
                      ></path>
                    </g>
                  </g>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <hr className="my-5" />
        <Link href="/" className="nav-title mb-4">
          Home
        </Link>
        <div className="px-6 grid grid-cols-1 gap-2">
          <Link href="/newsletter">{t("Title_Newsletter")}</Link>
          <Link href="/quiz">{t("Quiz")}</Link>
        </div>
        <hr className="my-5" />
        <Link href="/news/all/1" className="nav-title">
          {t("Title_News")}
        </Link>
        <hr className="my-5" />
        <Link
          href="/bundesliga/gameschedule/current/current/all"
          className="nav-title mb-4"
        >
          {t("Title_Bundesliga")}
        </Link>
        <div className="px-6 grid grid-cols-1 gap-2">
          {/* TODO: Get dynamic url */}
          <Link href="/bundesliga/gameschedule/current/current/all">
            {t("Title_Game_Schedule")}
          </Link>
          <Link href="/bundesliga/table">{t("Title_Table")}</Link>
          <Link href="/bundesliga/ranking/all/single">
            {t("Title_Rankings")}
          </Link>
          <Link href="/bundesliga/teams">{t("Title_Teams")}</Link>
          <Link href="/bundesliga/spectators">{t("Title_Spectators")}</Link>
          {/* <Link href="/bundesliga/players">{t("Title_Player_Portraits")}</Link> */}
          <Link href="/bundesliga/transferlist">{t("Title_Transfers")}</Link>
          <Link href="/bundesliga/finals">{t("Title_TTBL_Finals")}</Link>
          {/* <Link href="/bundesliga/finals/news">{t("Title_News")}</Link>
          <Link href="/bundesliga/finals/sponsors">
            {t("Title_Sponsors_And_Partners")}
          </Link>
          <Link href="/bundesliga/finals/tickets">{t("Title_Tickets")}</Link>
          <Link href="/bundesliga/finals/photobooth">
            {t("Title_Photo_Booth")}
          </Link>
          <Link href="/bundesliga/finals/gallery/2020-2021">
            {t("Title_Gallery")} 2020/2021
          </Link>
          <Link href="/bundesliga/finals/gallery/2019-2020">
            {t("Title_Gallery")} 2019/2020
          </Link>
          <Link href="/bundesliga/finals/gallery/2018-2019">
            {t("Title_Gallery")} 2018/2019
          </Link> */}
        </div>
        <hr className="my-5" />
        <Link
          href="/pokal/gameschedule/current/current/all"
          className="nav-title mb-4"
        >
          {t("Title_Pokal")}
        </Link>
        <div className="px-6 grid grid-cols-1 gap-2">
          {/* TODO: Get dynamic url */}
          <Link href="/pokal/gameschedule/current/current/all">
            {t("Title_Game_Schedule")}
          </Link>
          {/* <Link href="/pokal/teams">{t("Title_Teams")}</Link> */}
          <Link href="/pokal/finals">{t("Title_Pokal_Finals")}</Link>
          {/* <Link href="/pokal/finals/news">{t("Title_News")}</Link>
          <Link href="/pokal/finals/sponsors">
            {t("Title_Sponsors_And_Partners")}
          </Link>
          <Link href="/pokal/finals/tickets">{t("Title_Tickets")}</Link>
          <Link href="/pokal/finals/photobooth">{t("Title_Photo_Booth")}</Link>
          <Link href="/pokal/finals/gallery/2020-2021">
            {t("Title_Gallery")} 2020/2021
          </Link>
          <Link href="/pokal/finals/gallery/2019-2020">
            {t("Title_Gallery")} 2019/2020
          </Link>
          <Link href="/pokal/finals/gallery/2018-2019">
            {t("Title_Gallery")} 2018/2019
          </Link> */}
        </div>
        <hr className="my-5" />
        <Link href="/about" className="nav-title mb-4">
          {t("Title_The_TTBL")}
        </Link>
        <div className="px-6 grid grid-cols-1 gap-2">
          {/* <Link href="/about">{t("Title_The_TTBL")}</Link> */}
          <Link href="/about/ttblsportgmbh">{t("Title_TTBL_Sport_GmbH")}</Link>
          <Link href="/about/team">{t("Title_Team")}</Link>
          <Link href="/about/structure">{t("Title_Structure")}</Link>
          {/* <Link href="/about/socialproject">{t("Title_Social_Project")}</Link> */}
          <Link href="/about/partners">{t("Title_Partners")}</Link>
          {/* <Link href="/about/history">{t("Title_TTBL_History")}</Link> */}
          <Link href="/about/downloads">{t("Title_Downloads")}</Link>
          <Link href="/about/press">{t("Title_Press")}</Link>
          <Link href="/about/jobs">{t("Title_Jobs")}</Link>
          {/* <Link href="/about/rules">{t("Title_Rules_And_Orders")}</Link> */}
        </div>
        <hr className="my-5" />
        <Link href="/move-your-sport" className="nav-title mb-4">
          Move Your Sport
        </Link>
        <hr className="my-5" />
        <Link href="/newsletter">{t("Title_Newsletter")}</Link>
        <Link href="/privacy">{t("Title_Privacy_Policy")}</Link>
        <Link href="/imprint">{t("Title_Imprint")}</Link>
      </div>
      <hr className="my-5" />
      <div>@ 2023 by TTBL Sport GmbH</div>
    </div>
  ) : null;
}
